var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMesegs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_25287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 7.51953C21.5188 7.51953 22.75 6.28831 22.75 4.76953C22.75 3.25075 21.5188 2.01953 20 2.01953C18.4812 2.01953 17.25 3.25075 17.25 4.76953C17.25 6.28831 18.4812 7.51953 20 7.51953Z",
    fill: "#FF5364"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 8.76953C17.79 8.76953 16 6.97953 16 4.76953C16 4.03953 16.21 3.35953 16.56 2.76953H7C4.24 2.76953 2 4.99953 2 7.74953V13.7295V14.7295C2 17.4795 4.24 19.7095 7 19.7095H8.5C8.77 19.7095 9.13 19.8895 9.3 20.1095L10.8 22.0995C11.46 22.9795 12.54 22.9795 13.2 22.0995L14.7 20.1095C14.89 19.8595 15.19 19.7095 15.5 19.7095H17C19.76 19.7095 22 17.4795 22 14.7295V8.20953C21.41 8.55953 20.73 8.76953 20 8.76953Z",
    fill: "#FF5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.7695C11.44 12.7695 11 12.3195 11 11.7695C11 11.2195 11.45 10.7695 12 10.7695C12.55 10.7695 13 11.2195 13 11.7695C13 12.3195 12.56 12.7695 12 12.7695Z",
    fill: "#FF5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.7695C15.44 12.7695 15 12.3195 15 11.7695C15 11.2195 15.45 10.7695 16 10.7695C16.55 10.7695 17 11.2195 17 11.7695C17 12.3195 16.56 12.7695 16 12.7695Z",
    fill: "#FF5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.7695C7.44 12.7695 7 12.3195 7 11.7695C7 11.2195 7.45 10.7695 8 10.7695C8.55 10.7695 9 11.2195 9 11.7695C9 12.3195 8.56 12.7695 8 12.7695Z",
    fill: "#FF5364"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_25287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.769531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesegs);
export default __webpack_public_path__ + "static/media/mesegs.28a5942d7003e06e1f12b8da16903c79.svg";
export { ForwardRef as ReactComponent };